import { useAppDispatch } from '@/store/hooks';
import { openDialog } from '@fuse/core/FuseDialog/fuseDialogSlice';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { IconButton } from '@mui/material';
import { useNewHelp } from '@/utils/newHelpHook';
import HelpModal from './HelpModal';

export default function HelpWidget() {
  const dispatch = useAppDispatch();
  const { available, loading } = useNewHelp();

  const getHelp = () => {
    dispatch(
      openDialog({
        children: <HelpModal />,
        options: {
          maxWidth: 'md',
        }
      })
    );
  };

  if (loading || !available) return null;

  return <IconButton color="primary" onClick={getHelp}><FuseSvgIcon>heroicons-outline:question-mark-circle</FuseSvgIcon></IconButton>
}
